/**
 * This file is auto-generated from BodyHeight.loc.yaml
 * Do not edit this file directly. Edit the source file instead.
 */
export const label = lang => {
    switch (lang) {
        case 'en':
            return 'Height';
        case 'pl':
            return 'Wzrost';
    }
};
export const unitLabel = lang => {
    switch (lang) {
        case 'en':
            return 'Height unit';
        case 'pl':
            return 'Jednostka wzrostu';
    }
};
//# sourceMappingURL=BodyHeight.loc.js.map